import { render, staticRenderFns } from "./cv.vue?vue&type=template&id=63ac3d1a&scoped=true&"
import script from "./cv.vue?vue&type=script&lang=js&"
export * from "./cv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ac3d1a",
  null
  
)

export default component.exports